import Cookies from "js-cookie";
import OrganizationDetail from "./orgDetail";
import OrganizationList from "./orgList";


export default function OrganizationPage() {
    const webAdmin = Cookies.get('webAdmin') === 'T';

    if (!webAdmin) {
        return <OrganizationDetail/>;
    }

    return <OrganizationList/>;
}